import { RotateCcw } from "lucide-react";
import { Button } from "../../../shared-ui/primitives";
import "./DraftRecoveryBanner.css";

export function DraftRecoveryBanner({
  savedAt,
  onRestore,
  onDiscard,
}: {
  savedAt: string;
  onRestore: () => void;
  onDiscard: () => void;
}) {
  const time = new Date(savedAt).toLocaleTimeString("sr-RS", { hour: "2-digit", minute: "2-digit" });
  return (
    <div className="nx-draft-banner" role="alert">
      <span>Pronađene su nesačuvane izmene od {time}.</span>
      <div className="nx-draft-banner__actions">
        <Button size="sm" variant="primary" onClick={onRestore}>
          <RotateCcw size={16} />
          Vrati ih
        </Button>
        <Button size="sm" variant="ghost" onClick={onDiscard}>
          Odbaci
        </Button>
      </div>
    </div>
  );
}
